import React, { useState } from "react";
import { getFunctions, httpsCallable,connectFunctionsEmulator } from "firebase/functions";

const BillingManagement = () => {
  const [loading, setLoading] = useState(false);

  const openPortal = async () => {
    setLoading(true);
    try {
      const functions = getFunctions();
      if (process.env.NODE_ENV === "development") {
        // console.log('connecting to local host')
        connectFunctionsEmulator(functions, "localhost", 5001);
      }
      const createPortalLink = httpsCallable(functions, "createPortalLink");
      const result = await createPortalLink();
      window.location.href = result.data.url;
    } catch (err) {
      console.error("Error redirecting to billing portal:", err);
      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-white dark:bg-gray-800 rounded-lg shadow">
      <h2 className="text-2xl font-bold mb-4">Manage Your Subscription</h2>
      <p className="mb-6 text-gray-600 dark:text-gray-300">
        You can view your invoices, update your payment method, or cancel your plan.
      </p>
      <button
        onClick={openPortal}
        disabled={loading}
        className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700"
      >
        {loading ? "Loading..." : "Open Billing Portal"}
      </button>
    </div>
  );
};

export default BillingManagement;
